import type { ReactNode } from "react";
import Icon from "app/components/shared/Icon";

export default function Wrapper({
  title,
  icon,
  children,
}: {
  title: string;
  icon: string;
  children: ReactNode;
}) {
  return (
    <div className="flex gap-2 items-baseline">
      <dt>
        <Icon
          aria-label={title}
          className="h-4 w-4 text-gray-700"
          icon={icon}
          title={title}
        />
      </dt>
      <dd>{children}</dd>
    </div>
  );
}
